import * as React from 'react';
import { mouseEventProps } from './mouseEventProps';
import { joinClass } from './symbolUtils';
export const Stage = ({ children, inEditor, symbol, }) => {
    const { clickClass, mouseEventStyles, onClick } = mouseEventProps(symbol, inEditor);
    const className = joinClass('stage', clickClass);
    return (React.createElement("div", { className: className, onClick: onClick, style: Object.assign(Object.assign({}, mouseEventStyles), { backgroundColor: 'white', height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }) }, children));
};
export default Stage;
